import React from 'react';
import TweetsWrapper from '../../components/TweetsWrapper';
import InlineError from '../../components/InlineError';

import './splitLayout.scss';

export default ({ styleClass, fontClass, config, error, generateCustomStyles }) => {
  return (
    <div
      className={`app ${styleClass} ${fontClass}`}
      style={{ backgroundColor: config.background_color }}
    >
      <style dangerouslySetInnerHTML={{ __html: generateCustomStyles(config) }}></style>
      <TweetsWrapper config={config} />
      {error && <InlineError error={error} text={config.configKey} />}
    </div>
  );
};
